module.exports = __webpack_public_path__ + "static/we-assemble-your-team-06b794670f77d168e19807a1529b1d49.svg";